import React from 'react';
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize';
import { customDateFormatter } from './TablePR';

export const TableGRN = (props: any) => {
  const { data, name, docType, page, pageLength } = props;
  // const [width] = useMediaQuery()
  const [width] = useMediaQuery();

  let fontSize;
  if (width < 769) {
    fontSize = 7;
  } else {
    fontSize = 10;
  }

  return (
    <>
      {/* GRN table */}
      {docType === 'delivery-order' && (
        <div style={{ fontSize }}>
          <div style={{ display: 'flex' }}>
            {/* Left Column */}
            <span style={{ width: '60%', padding: '8px' }}>
              <table style={{ marginTop: '5px', borderCollapse: 'collapse' }}>
                <tr>
                  <td>
                    <b>{data?.Supplier?.CompanyName}</b>
                  </td>
                </tr>
                <tr>
                  {data?.Supplier?.Address?.address}
                  <br />
                  {data?.Supplier?.Address?.postCode}{' '}
                  {data?.Supplier?.Address?.city}
                  <br />
                  {data?.Supplier?.Address?.state}
                  <br />
                  {data?.Supplier?.Address?.country}
                  <br />
                </tr>
              </table>

              <table style={{ marginTop: '5px', borderCollapse: 'collapse' }}>
                <tr>
                  <td>GST No.</td>
                  <td>:</td>
                  <td>{data?.Supplier?.GSTRegNo ?? ''}</td>
                </tr>
                <tr>
                  <td>Attn. </td>
                  <td>:</td>
                  <td>{data?.Supplier?.CreditorContact?.Name ?? ''}</td>
                </tr>
                <tr>
                  <td>Tel No. </td>
                  <td>:</td>
                  <td>{data?.Supplier?.CreditorContact?.ContactNo ?? ''}</td>
                </tr>
                {data?.Supplier?.CreditorContact?.Email && (
                  <tr>
                    <td>Email </td>
                    <td>:</td>
                    <td>{data?.Supplier?.CreditorContact?.Email ?? ''}</td>
                  </tr>
                )}
              </table>
            </span>

            {/* Right Column */}
            <span style={{ width: '40%', padding: '8px' }}>
              <table style={{ borderCollapse: 'collapse' }}>
                <>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>GRN No. </td>
                    <td>:</td>
                    <td>
                      <b>{data?.DocNo}</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>GRN Date</td>
                    <td>:</td>
                    <td>{customDateFormatter(data?.DocDate)}</td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>DO No. </td>
                    <td>:</td>
                    <td>{data?.DoNo}</td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>DO Date </td>
                    <td>:</td>
                    <td>{customDateFormatter(data?.TransactionDate)}</td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>Delivery Location</td>
                    <td>:</td>
                    <td>{name}</td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>Page </td>
                    <td>:</td>
                    <td>
                      {page + 1} / {pageLength}
                    </td>
                  </tr>
                </>
              </table>
            </span>
          </div>
        </div>
      )}

      {/* GRTN table */}
      {docType === 'good-return-note' && (
        <div style={{ fontSize }}>
          <div style={{ display: 'flex' }}>
            {/* Left Column */}
            <span style={{ width: '60%', padding: '8px' }}>
              <table style={{ marginTop: '5px', borderCollapse: 'collapse' }}>
                <tr>
                  <td>
                    <b>{data?.Supplier?.CompanyName}</b>
                  </td>
                </tr>
                <tr>
                  {data?.Supplier?.Address?.address}
                  <br />
                  {data?.Supplier?.Address?.postCode}{' '}
                  {data?.Supplier?.Address?.city}
                  <br />
                  {data?.Supplier?.Address?.state}
                  <br />
                  {data?.Supplier?.Address?.country}
                  <br />
                </tr>
              </table>

              <table style={{ marginTop: '5px', borderCollapse: 'collapse' }}>
                <tr>
                  <td>GST No.</td>
                  <td>:</td>
                  <td>{data?.Supplier?.GSTRegNo ?? ''}</td>
                </tr>
                <tr>
                  <td>Attn. </td>
                  <td>:</td>
                  <td>{data?.Supplier?.CreditorContact[0]?.Name ?? ''}</td>
                </tr>
                <tr>
                  <td>Tel No. </td>
                  <td>:</td>
                  <td>{data?.Supplier?.CreditorContact[0]?.ContactNo ?? ''}</td>
                </tr>
                <tr>
                  <td>Email </td>
                  <td>:</td>
                  <td>{data?.Supplier?.CreditorContact[0]?.Email ?? ''}</td>
                </tr>
              </table>
            </span>

            {/* Right Column */}
            <span style={{ width: '40%', padding: '8px' }}>
              <table style={{ borderCollapse: 'collapse' }}>
                <>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>GRTN No. </td>
                    <td>:</td>
                    <td>
                      <b>{data?.DocNo}</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>GRTN Date</td>
                    <td>:</td>
                    <td>{customDateFormatter(data?.DocDate)}</td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>DO No. </td>
                    <td>:</td>
                    <td>{data?.RefNo}</td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>Return Date </td>
                    <td>:</td>
                    <td>{customDateFormatter(data?.TransactionDate)}</td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>Return Location</td>
                    <td>:</td>
                    <td>{name}</td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: '20px' }}>Page </td>
                    <td>:</td>
                    <td>
                      {page + 1} / {pageLength}
                    </td>
                  </tr>
                </>
              </table>
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default TableGRN;
